import { type INTEGRATIONS, type INTEGRATIONS_V2 } from '../../../components/IntegrationButton';
import { LogoWrapper } from './styles';

const LOGOS = {
  a3api: 'a3api.png',
  factorial: 'factorial-logo.svg',
  personio: 'logo-personio.svg',
  grupoCastillaEpsilon: 'gc_logo.svg',
  api: 'integrations/api.png',
  buk: 'integrations/buk.png',
  bizneo: 'integrations/bizneo.png'
};

type LogoProps = {
  logoName: INTEGRATIONS | INTEGRATIONS_V2;
};

export const Logo = ({ logoName }: LogoProps) => {
  const logoFileName = LOGOS[logoName as keyof typeof LOGOS] || '';

  if (!logoFileName) {
    return <></>;
  }

  return (
    <LogoWrapper
      src={`/images/${logoFileName}`}
      onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = '/images/integrations/default.png';
      }}
    />
  );
};
